import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ContactForm } from "./ContactForm";
import type { Contact, ContactFormData } from "@/types/contact";

interface ContactFormWrapperProps {
  editingContact?: Contact;
  onSubmit: (data: ContactFormData) => void;
  onCancel: () => void;
}

export const ContactFormWrapper = ({
  editingContact,
  onSubmit,
  onCancel,
}: ContactFormWrapperProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          {editingContact ? "Editar Contato" : "Novo Contato"}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ContactForm
          onSubmit={onSubmit}
          initialData={editingContact}
          onCancel={onCancel}
          isEditing={!!editingContact}
        />
      </CardContent>
    </Card>
  );
};